import { Price_Type } from "../../models/RestModels";

export function getEmptyPriceType(): Price_Type
{
		return {
			installments: 0,
			show_bill_code: 'NO',
			tax_model: 'ALL',
			type: 'RETAIL',
			wholesale_min_qty: 0,
			wholesale_type: 'BY_TAG',
			json_tags: [],
		};
}
